module.exports = __webpack_public_path__ + "img/logo2.13ebe692.png";